import { func, object } from 'prop-types';
import React from 'react';

import QuestionBlock from './QuestionBlock';
import RehabHeader from './RehabHeader';

const Rehab7 = ({ fm, data }) => {
  return (
    <React.Fragment>
      <RehabHeader fm={fm} rehab={7} date={data.finished} />

      <QuestionBlock
        question={fm('npView.rehab7.fatigueNow')}
        answer={
          data.currentFatigueStatusSelected
            ? fm(`onlineRehabilitation.controlSteps.${data.currentFatigueStatusSelected}`)
            : null
        }
      />
      <QuestionBlock
        question={fm('npView.rehab7.cognitionNow')}
        answer={
          data.currentCognitionStatusSelected
            ? fm(`onlineRehabilitation.controlSteps.cognition.${data.currentCognitionStatusSelected}`)
            : null
        }
      />
      <QuestionBlock question={fm('onlineRehabilitation.rehab7.3.fatigueTarget')} answer={data.targetFatigue} />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab7.3.fatigueMeans')}
        answer={data.plannedChangesToManageFatigue}
      />
      <QuestionBlock question={fm('onlineRehabilitation.rehab7.3.cognitionTarget')} answer={data.targetCognition} />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab7.3.cognitionMeans')}
        answer={data.plannedChangesToManageCognitiveProblems}
      />
    </React.Fragment>
  );
};

Rehab7.propTypes = {
  fm: func,
  data: object,
};
export default Rehab7;
